<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Box" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Box" @click="onDelete(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <configurazione-agenda-box-edit-modal-component ref="cmpConfigurazioneAgendaBoxEditModal" @afterSave="onAfterSave"></configurazione-agenda-box-edit-modal-component>
    </div>
</template>
<script>
import axios from "axios";
import ConfigurazioneAgendaBoxEditModalComponent from "./ConfigurazioneAgendaBoxEditModalComponent.vue";
export default {
    components: { ConfigurazioneAgendaBoxEditModalComponent },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            filtroConfigurazioneAgendaBox: {},
            pathResource: "/agendebox",
            showModalLoading: false,
            show: true,
            perPage: 50,
            currentPage: 1,
            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            items: [],

            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Nome", key: "nome", sortable: true },
                { label: "Note", key: "note", sortable: true },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            this.openShowModalLoading();
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroConfigurazioneAgendaBox"]) {
                me.filtroConfigurazioneAgendaBox = JSON.parse(sessionStorage["filtroConfigurazioneAgendaBox"]);
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroConfigurazioneAgendaBox.page = me.currentPage;
            me.filtroConfigurazioneAgendaBox.forPage = me.perPage;
            axios
                .get(link, { params: me.filtroConfigurazioneAgendaBox })
                .then((response) => {
                    me.rows = response.data.data.list.length;
                    me.items = response.data.data.list;
                    me.listKey++;
                    me.closeShowModalLoading();
                })
                .catch(() => {
                    me.closeShowModalLoading();
                });
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onEdit(item) {
            let me = this;
            me.$refs.cmpConfigurazioneAgendaBoxEditModal.edit(item.id);
        },
        nuovo() {
            let me = this;
            me.$refs.cmpConfigurazioneAgendaBoxEditModal.show();
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare il Box Agenda " + item.nome)
                .then((value) => {
                    if (value) {
                        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                        axios.delete(link + item.id).then(() => {
                            me.loadData();
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
